import { usePrimaryFilterState } from '../../filters/hooks/usePrimaryFilterState';
import { isPrimaryFilterId } from '../../filters/utils/common';
import { useFilterTags } from '../FilterBar/useFilterTags';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';

export const useHasSelectedFilters = (): boolean => {
  const { primaryFilter } = useTabContentConfig();
  const primaryFilterId =
    primaryFilter && isPrimaryFilterId(primaryFilter.id)
      ? primaryFilter.id
      : undefined;
  const { activePrimaryFilterLength } = usePrimaryFilterState(primaryFilterId);
  const { filterTags } = useFilterTags();

  return activePrimaryFilterLength > 0 || filterTags.length > 0;
};
